import React, { useEffect, useState } from "react"

import SectionContainer from "components/molecules/common/SectionContainer"

const RedirectPage = () => {
  const [link, setLink] = useState<string>()

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    setLink(urlParams.get("link"))
  }, [])

  return (
    <SectionContainer className="bg-white">
      {link ? (
        <iframe
          className="left-0 top-0 mb-0 h-screen w-full rounded-lg "
          src={link}
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      ) : null}
    </SectionContainer>
  )
}

export default RedirectPage
